export default __webpack_public_path__ + "static/media/logo.81f99945.svg";